export default __webpack_public_path__ + "static/media/courage_to_accept_challenges.7f824060.png";